"use client";

import { NEXT_PUBLIC_CDN_URL } from "@/libs/constants/auth";
import ErrorScreen from "@/components/ErrorScreen";
import styles from "./global-error.module.scss";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  return (
    <html>
      <body>
        <div className={styles.pnfContainer}>
          <div className={"container"}>
            <div className={"errorWrap"}>
              <ErrorScreen
                errorImage={`${NEXT_PUBLIC_CDN_URL}/images/ui_revamp_desktop404.svg`}
                prefixTitle="Oooops!"
                postfixTitle="We’re efwrgfessgwsf"
                subTitle="Seems like we've lost our way in the medical maze. Stay tuned as we navigate back to the right path.
        "
                ctaText="Go to Home Page"
                onClick={() => reset}
              />
            </div>
          </div>
        </div>
      </body>
    </html>
  );
}
